"use client";

import { MessageDraft } from "../hooks/use-chat-draft";
import { createContext, useContext } from "react";
export interface ChatInputContextValue {
  // Draft state
  draftContent: string;
  draft: MessageDraft | null;
  handleDraftChange: (text: string) => void;
  clearDraft: () => void;

  // File handling
  selectedFiles: File[];
  addFiles: (files: File[]) => void;
  removeFile: (index: number) => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  previewFile: File | null;
  setPreviewFile: (file: File | null) => void;
  previewFileUrl: string | null;
  clearFiles: () => void;
}
export const ChatInputContext = createContext<ChatInputContextValue | null>(null);
export function useChatInputContext() {
  const context = useContext(ChatInputContext);
  if (!context) {
    throw new Error("useChatInputContext must be used within a ChatInputProvider");
  }
  return context;
}